import React from "react";

const ContactUs = () => {
  return (
    <>
      <h1 className="text-center">Contact Us</h1>
    </>
  );
};

export default ContactUs;
